import * as React from 'react';

import { IRubricsLinksState } from '../../../../types/rubricsLinks';
import { ISpecialPromo } from '../../../../types/specialPromos';
import * as styles from './Rubrics.css';
import { RubricItem } from './components/RubricItem';
import { RUBRICS } from './constants';

interface IRubricsProps {
  links: IRubricsLinksState;
  specialPromo?: ISpecialPromo | null;
  onRubricClick(rubricKey: keyof IRubricsLinksState): void;
  onSpecialPromoCLick(): void;
}

export const Rubrics: React.FC<IRubricsProps> = ({ links, specialPromo, onRubricClick, onSpecialPromoCLick }) => {
  return (
    <ul className={styles['container']}>
      {RUBRICS.map(rubric => {
        if (!links[rubric.key]) {
          return null;
        }

        return (
          <RubricItem
            key={`rubric_${rubric.title}`}
            href={links[rubric.key] as string}
            onClick={() => onRubricClick(rubric.key)}
          >
            {rubric.title}
          </RubricItem>
        );
      })}
      {specialPromo && (
        <RubricItem href={specialPromo.mobileUrl} onClick={onSpecialPromoCLick}>
          Новостройки от {specialPromo.nameGenitive}
          {specialPromo.mobileLogoUrl && (
            <span className={styles['logo']} style={{ backgroundImage: `url("${specialPromo.mobileLogoUrl}")` }} />
          )}
        </RubricItem>
      )}
    </ul>
  );
};
